import { NgModule, inject } from '@angular/core';
import { Route, RouterModule } from '@angular/router';
import { environment } from 'src/environments/environment';
import { FullComponent } from './layouts/full/full.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { MarketplaceComponent } from './marketplace/marketplace.component';
import { SelfcaringComponent } from './selfcaring/selfcaring.component';
import { AppGuard } from './services/guards/app.guard';
import { LoginComponent } from './login/login.component';
import { PreloadAllModules } from '@angular/router';
import { UserCompleteGuard } from './services/guards/userComplete.guard';
import { CompleteProfileComponent } from './complete-profile/complete-profile.component';
import { VerifyTokenComponent } from './verify-token/verify-token.component';
import { ReportComponent } from './report/report.component';
import { ProductPageComponent } from './product-page/product-page.component';
import { VideoRecorderComponent } from './shared/components/video-recorder/video-recorder.component';
import { OrderCompleteComponent } from './order-complete/order-complete.component';
import { VideoRecorderOldComponent } from './shared/video-recorder-old/video-recorder-old.component';
import { LandingComponent } from './landing/landing.component';
import { FullStandaloneComponent } from './layouts/standalone/full-standalone.component';
import { BollettaComponent } from './bolletta/bolletta.component';
import { AssessmentComponent } from './assessment/assessment.component';
import { DoubleGuard } from './services/guards/double.guard';
import { DashboardDynamicComponent } from './dashboard-dynamic/dashboard-dynamic.component';
import { RegistrationRequestComponent } from './registration-request/registration-request.component';
import { SectionBollettaComponent } from './dashboard-dynamic/components/section-bolletta/section-bolletta.component';

export declare interface CustomRoute extends Route {
  wpRoute?: string | null;
  wpRouteMatch?: 'startsWith' | 'endsWith' | 'equals';
  wpRouteParams?: {
    urlParam: string;
    routeParam: string;
  }[];
  children?: CustomRoutes;
}

export declare type CustomRoutes = CustomRoute[];

export const routes: CustomRoutes = [
  {
    path: '',
    redirectTo: '/' + environment.routingBasePath+'/dashboard-dynamic',
    pathMatch: 'full',
  },
  {
    path: 'mio-account/dashboard-2-0',
    redirectTo: '/' + environment.routingBasePath+'/dashboard-dynamic',
    pathMatch: 'full',
  },
  {
    path: 'mio-account/marketplace-2',
    redirectTo: '/' + environment.routingBasePath+'/marketplace',
    pathMatch: 'full',
  },
  {
    path: 'mio-account/dashboard-selfcaring',
    redirectTo: '/' + environment.routingBasePath+'/selfcaring',
    pathMatch: 'full',
  },
  {
    path: 'digital-report',
    redirectTo: '/' + environment.routingBasePath+'/digital-report',
    pathMatch: 'full',
  },
  {
    path: environment.routingBasePath + '/landing',
    component: FullStandaloneComponent,
    children: [
      {
        path: '',
        component: LandingComponent
        // loadChildren: () => import('./landing/landing.component').then(m => m.LandingComponent)
      }
    ]
  },
  {
    path: environment.routingBasePath + '/bolletta',
    component: BollettaComponent,
  },
  {
    path: environment.routingBasePath + '/assessment',
    component: AssessmentComponent,
    canActivate: [() => inject(DoubleGuard).canActivate()]
  },
  {
    path: environment.routingBasePath,
    component: FullComponent,
    children: [
      {
        path: '',
        redirectTo: 'dashboard-dynamic',
        pathMatch: 'full',
      },
      {
        path: 'login',
        component: LoginComponent
      },
      {
        path: 'verify-token',
        component: VerifyTokenComponent
      },
      {
        path: 'dashboard',
        component: DashboardComponent,
        canActivate: [() => inject(AppGuard).canActivate(), () => inject(UserCompleteGuard).canActivate()]
        // loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule)
      },
      {
        path: 'dashboard-dynamic',
        component: DashboardDynamicComponent,
        // canActivate: [() => inject(AppGuard).canActivate(), () => inject(UserCompleteGuard).canActivate()]
        canActivate: [() => inject(DoubleGuard).canActivate()]

      },
      {
        path: 'innovation-path',
        // component:InnovationPathComponent
        loadChildren: () => import('./innovation-path/innovation-path.module').then(m => m.InnovationPathModule),
        canActivateChild: [() => inject(AppGuard).canActivate(), () => inject(UserCompleteGuard).canActivate()]
      },
      {
        path: 'marketplace',
        component: MarketplaceComponent,
        canActivate: [() => inject(AppGuard).canActivate(), () => inject(UserCompleteGuard).canActivate()]
        // loadChildren: () => import('./marketplace/marketplace.module').then(m => m.MarketplaceModule)
      },
      {
        path: 'digital-report',
        // loadChildren: () => import('./report/report.module').then(m => m.ReportModule),
        component: ReportComponent,
        canActivate: [() => inject(AppGuard).canActivate(), () => inject(UserCompleteGuard).canActivate()]
      },
      {
        path: 'progetto-innovativo',
        component: SectionBollettaComponent,
        canActivate: [() => inject(AppGuard).canActivate(), () => inject(UserCompleteGuard).canActivate()]
    },
      {
        path: 'cart',
        loadChildren: () => import('./cart/cart.module').then(m => m.CartModule),
        canActivate: [() => inject(AppGuard).canActivate(), () => inject(UserCompleteGuard).canActivate()]
      },
      {
        path: 'selfcaring',
        component: SelfcaringComponent
        // loadChildren: () => import('./selfcaring/selfcaring.module').then(m => m.SelfcaringModule)
      },
      {
        path: 'bandi',
        loadChildren: () => import('./bandi/bandi.module').then(m => m.BandiModule)
        // component: BandiComponent
      },
      {
        path: 'oe',
        loadComponent: () => import('./obiettivo-europa-list/obiettivo-europa-list.component').then(m => m.ObiettivoEuropaListComponent),
        // component: BandiComponent
      },
      {
        path: 'user-profile',
        // loadChildren: () => import('./user-profile/user-profile.module').then(m => m.UserProfileModule),
        loadComponent: () => import('./user-profile/user-profile.component').then(m => m.UserProfileComponent),
        // component: UserProfileComponent
      },
      {
        path: 'completeProfile',
        canActivate: [() => inject(AppGuard).canActivate()],
        component: CompleteProfileComponent
      },
      {
        path: 'registration',
        // canActivate: [() => inject(DoubleGuard).canActivate()],
        component: RegistrationRequestComponent
      },
      { // DEPRECATED
        path: 'order-complete',
        canActivate: [() => inject(AppGuard).canActivate()],
        // component: OrderCompleteComponent
        loadChildren:() => import ('./order-complete/order-complete.module').then(m => m.OrderCompleteModule)
      },
      {
        path: 'order-acceptance',
        canActivate: [() => inject(AppGuard).canActivate()],
        // component: OrderCompleteComponent
        loadComponent: () => import('./order-complete/order-complete.component').then(m => m.OrderCompleteComponent)
      },
      {
        path: 'product/:sku',
        // canActivate: [() => inject(AppGuard).canActivate()],
        canActivate: [() => inject(DoubleGuard).canActivate()],
        // component: ProductPageComponent
        loadComponent: () => import('./product-page/product-page.component').then(m => m.ProductPageComponent)
      },
      {
        path: 'video',
        canActivate: [() => inject(AppGuard).canActivate()],
        component: VideoRecorderOldComponent
      },
      {
        path: 'playmetrics',
        canActivate: [() => inject(AppGuard).canActivate()],
        // component: ProductPageComponent
        loadComponent: () => import('./products-landings/playmetrics/playmetrics.component').then(m => m.PlaymetricsComponent)
      },
      // define a path for unexisting routes that redirect on marketplace
      {
        path: '**',
        redirectTo: 'dashboard-dynamic',
        pathMatch: 'full'
      }
      // {
      //   path: '',
      //   loadChildren:
      //     () => import('./material-component/material.module').then(m => m.MaterialComponentsModule)
      // }
    ]
  },
 
];




@NgModule({
  imports: [RouterModule.forRoot(
    routes,
    {
      scrollPositionRestoration: 'top',
      preloadingStrategy: PreloadAllModules
    })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
